'use client';
import React from 'react';

const steps = [
  {
    number: '01',
    icon: '📍',
    title: 'Drop your pin',
    description: 'Tell us where you are. Mdeliva finds every vendor delivering to your exact location right now.',
  },
  {
    number: '02',
    icon: '🛒',
    title: 'Pick your order',
    description: 'Browse menus, read real reviews, and build your order. Filter by cuisine, price, or delivery time.',
  },
  {
    number: '03',
    icon: '🚴',
    title: 'Sit back & track',
    description: 'Your rider picks up and heads straight to you. Track every turn on the live map until it arrives.',
  },
];

export default function TheProcess() {
  return (
    <section className="py-16 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Section Label */}
        <div className="flex justify-center mb-6">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest bg-[#1a0e00] border border-[#3d2000] text-[#f97316]">
            THE PROCESS
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">
          Three steps to full.
        </h2>

        {/* Steps */}
        <div className="space-y-8">
          {steps?.map((step, i) => (
            <div key={i} className="flex items-start gap-6 relative">
              {/* Step Icon */}
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center text-2xl">
                {step?.icon}
              </div>

              {/* Content */}
              <div className="flex-1 pt-1">
                <h3 className="text-white font-bold text-lg mb-1">{step?.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{step?.description}</p>
              </div>

              {/* Step Number */}
              <div
                className="flex-shrink-0 text-6xl font-black leading-none"
                style={{ color: 'rgba(255,255,255,0.05)' }}
              >
                {step?.number}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
